import axios from 'axios'
import qs from "qs";
export const VERSION = process.env.REACT_APP_VERSION
export const BASENAME = process.env.REACT_APP_BASENAME

export const APIKEY = process.env.REACT_APP_APIKEY
export const BASEURL = `${BASENAME}/v${VERSION}`

export const api = axios.create({
    baseURL: BASEURL,
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
});

// simdb

export const getStates = (params) => {
  return api.get(`/simdb/states/`, {params})
};

export const getRunMetaData = (params) => {
  return api.get('/simdb/run-meta-data/', {params})
};

export const getSimulation = (id) => {
  return api.get(`/simulation/${id}/`)
}

export const patchSimulation = (id, params) => {
  return api.patch(`/simulation/${id}/`, params)
}

export const getCorRuns = (params) => {
  return api.get('/simdb/cor-runs/', {
    params: params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' });  // list_one=value1&list_one=value2
    }
  })
};

export const getParamChoices = (params) => {
  return api.get('/simdb/param-choices/', {params})
};

export const postSession = (id) => {
  return api.post(`/session/${id}/`)
};

export const getDatafiles = (params) => {
  return api.get('/api/fetch-data/', {
    responseType: 'blob',
    params: params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' });  // list_one=value1&list_one=value2
    }
  })
};

// tools

export const getPlot = (id, tool) => {
  let url = `${tool}/${id}/run-plotting/`;
  return api.get(url)
}

export const getTool = (id, tool) => {
  return api.get(`${tool}/${id}/fetch-all/`)
}

export const patchWidget = (id, tool, widget, params) => {
  let url = `${tool}/${id}/${widget}/validate/plot/`;
  return api.patch(url, params, {headers: {'Content-Type': 'application/json'}});
}

export const getData = (id, tool, ext) => {
  return api.get(`${tool}/${id}/${ext}/fetch-data/`, { responseType: 'blob' })
};

// helpers

export const getScTranges = () => {
  return api.get(`/api/spacecraft-tranges/`)
};

export const getDtToCr = (params) => {
  return api.get('/api/dt-to-cr', {params})
};

export const getCrToDt = (params) => {
  return api.get('/api/cr-to-dt', {params})
};
